import React from 'react';
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const CursosPage = lazy(() => import('../pages/cursos/page'));
const CursoDetalhadoPage = lazy(() => import('../pages/curso-detalhado/page'));
const MentoriaPage = lazy(() => import('../pages/mentoria/page'));
const ConsultoriaPage = lazy(() => import('../pages/consultoria/page'));
const AgentesIAPage = lazy(() => import('../pages/agentes-ia/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ObrigadoPage = lazy(() => import('../pages/obrigado/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PoliticaDePrivacidadePage = lazy(() => import('../pages/politica-de-privacidade/page'));
const TermosDeUsoPage = lazy(() => import('../pages/termos-de-uso/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <CursoDetalhadoPage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/cursos',
    element: <CursosPage />
  },
  {
    path: '/curso-detalhado',
    element: <CursoDetalhadoPage />
  },
  {
    path: '/mentoria',
    element: <MentoriaPage />
  },
  {
    path: '/consultoria',
    element: <ConsultoriaPage />
  },
  {
    path: '/agentes-ia',
    element: <AgentesIAPage />
  },
  {
    path: '/sobre',
    element: <SobrePage />
  },
  {
    path: '/obrigado',
    element: <ObrigadoPage />
  },
  {
    path: '/politica-de-privacidade',
    element: <PoliticaDePrivacidadePage />
  },
  {
    path: '/termos-de-uso',
    element: <TermosDeUsoPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
